
<div class="progress-container">
  <div class="progress-content">
    <!-- ===== Progreso Desktop/Tablet ===== -->
    <section class="show-desktop-tablet">
      <div class="progress-bar-container mb-24">
        <mat-progress-bar class="custom-progress-bar" [mode]="'determinate'"></mat-progress-bar>
      </div>

      <div class="progress-levels d-flex justify-content-between mb-32">
        <!-- Nivel Bronce -->
        <div class="level-item text-start d-flex">
          <div class="ta-s">
            <img src="/assets/image/partners-ali/icon-badge-bronce.svg" alt="Bronce" class="level-icon" />
            <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Bronce</p>
            <p class="level-amount fts-12 font-regular color-title-custom m-0">
              <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
            </p>
          </div>
        </div>

        <!-- Nivel Plata -->
        <div class="level-item ta-c">
          <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
          <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Plata</p>
          <p class="level-amount fts-12 font-regular color-title-custom m-0">
            <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
          </p>
        </div>

        <!-- Nivel Oro -->
        <div class="level-item ta-c position-relative">
          <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
          <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Oro</p>
          <p class="level-amount fts-12 font-regular color-title-custom m-0">
            <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
          </p>
        </div>

        <!-- Nivel Diamante -->
        <div class="level-item d-flex justify-content-end">
          <div class="ta-r vw-100">
            <img src="/assets/image/partners-ali/icon-badge-diamond.svg" alt="Diamante" class="level-icon" />
            <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Diamante</p>
            <p class="level-amount fts-12 font-regular color-title-custom m-0">
              <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Progreso Móvil ===== -->
    <section class="show-mobile">
      <p-carousel #carouselGeneralALI
        [value]="cards"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="false"
        [showNavigators]="false"
        [showIndicators]="false"
        styleClass="custom-carousel-ALI"
      >
        <!-- Plantilla de ítems -->
        <ng-template pTemplate="item" let-card>
          <div class="dinamic-card">
            <ng-container [ngSwitch]="card.id">
              <div class="progress-bar-container mb-24">
                <mat-progress-bar class="custom-progress-bar" mode="determinate" color="primary"></mat-progress-bar>

                <!-- Card 1 -->
                <div *ngSwitchCase="1" class="progress-levels-mobile d-flex justify-content-between mt-16">
                  <!-- Bronce -->
                  <div class="level-item text-start d-flex">
                    <div class="ta-s">
                      <img src="/assets/image/partners-ali/icon-badge-bronce.svg" alt="Bronce" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Bronce</p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                  <!-- Plata -->
                  <div class="level-item ta-r" [ngClass]="{ 'fade-card': hasEntered }">
                    <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
                    <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Plata</p>
                    <p class="level-amount fts-12 font-regular color-title-custom m-0">
                      <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                    </p>
                  </div>
                </div>

                <!-- Card 2 -->
                <div *ngSwitchCase="2" class="progress-levels-mobile d-flex justify-content-between mt-16">
                  <!-- Plata -->
                  <div class="level-item text-start d-flex">
                    <div class="ta-s">
                      <img src="/assets/image/partners-ali/icon-badge-plata.svg" alt="Plata" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Plata</p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                  <!-- Oro -->
                  <div class="level-item ta-r position-relative" [ngClass]="{ 'fade-card': hasEntered2 }">
                    <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
                    <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Oro</p>
                    <p class="level-amount fts-12 font-regular color-title-custom m-0">
                      <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                    </p>
                  </div>
                </div>

                <!-- Card 3 -->
                <div *ngSwitchCase="3" class="progress-levels-mobile d-flex justify-content-between mt-16">
                  <!-- Oro -->
                  <div class="level-item text-start d-flex">
                    <div class="ta-s">
                      <img src="/assets/image/partners-ali/icon-badge-oro.svg" alt="Oro" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Oro</p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                  <!-- Diamante -->
                  <div class="level-item d-flex justify-content-end">
                    <div class="ta-r vw-100">
                      <img src="/assets/image/partners-ali/icon-badge-diamond.svg" alt="Diamante" class="level-icon" />
                      <p class="level-name fts-14 font-bold-dali color-title-custom mt-8 m-0">Aliado Diamante</p>
                      <p class="level-amount fts-12 font-regular color-title-custom m-0">
                        <ngx-skeleton-loader [theme]="{ width: '60px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-template>

        <!-- Navegación -->
        <ng-template pTemplate="footer">
          <div class="custom-carousel-nav vw-100 d-flex justify-content-between">
            <button type="button" class="custom-nav-button" [class.disabled]="carouselGeneralALI?.page === 0" [disabled]="carouselGeneralALI?.page === 0">
              <img src="assets/image/essentials/arrow-left.svg" alt="previous" />
            </button>

            <div class="custom-indicators d-sm-flex">
              <button *ngFor="let _ of getTotalPages(); let i = index" type="button" class="custom-indicator" [class.active]="carouselGeneralALI.page === i"></button>
            </div>

            <button type="button" class="custom-nav-button"
              [class.disabled]="carouselGeneralALI.page === getTotalPages().length - 1"
              [disabled]="carouselGeneralALI.page === getTotalPages().length - 1"
            >
              <img src="assets/image/essentials/arrow-right.svg" alt="next" />
            </button>
          </div>
        </ng-template>
      </p-carousel>
    </section>

    <!-- ===== Logros y tabla ===== -->
    <div class="achievements-section">
      <div class="achievements-grid d-flex justify-content-between">
        <div class="achievements-section">
          <h4 class="achievement-title fts-16 font-bold-dali color-title-custom m-0">
            Lo que has logrado y lo que puedes alcanzar
          </h4>

          <div class="achievements-grid d-flex justify-content-between grid-65-35 mt-24">
            <!-- Tabla facturación -->
            <section class="table-wrapper mb-16" *ngIf="billingData.length">
              <div class="container-border-line">
                <!-- Header -->
                <div class="title-table d-flex justify-content-center align-items-center">
                  <p class="fts-14 font-bold-dali color-title-custom m-0">Facturación mensual ({{ currentYear }})</p>
                </div>
                <hr class="dividing-line-solid m-0" />

                <!-- Cabecera -->
                <div class="d-flex justify-content-between p-16 header-table-awards row">
                  <div class="cell-box fts-14 font-bold-dali color-title-custom col-3" *ngFor="let trimestre of billingData">
                    Trimestre {{ trimestre.trimestre }}
                  </div>
                </div>
                <hr class="dividing-line-solid m-0" />

                <!-- Filas por mes -->
                <ng-container *ngFor="let i of [0,1,2]">
                  <div class="d-flex justify-content-between pv-12 ph-16 row">
                    <div class="cell-box fts-14 font-bold-dali color-title-custom col-3" *ngFor="let trimestre of billingData">
                      <div class="d-flex justify-content-between align-items-center vw-100">
                        <span>{{ trimestre.months[i].name }}</span>
                        <span class="font-regular fts-14">
                          <ngx-skeleton-loader [theme]="{ width: '30px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr class="dividing-line-solid m-0" />
                </ng-container>

                <!-- Totales por trimestre -->
                <div class="d-flex justify-content-between align-items-center p-16 row">
                  <div class="cell-box fts-14 font-bold-dali color-title-custom col-3" *ngFor="let trimestre of billingData">
                    <div class="d-flex justify-content-between align-items-center vw-100">
                      <div>Total:</div>
                      <div class="font-bold-dali fts-14">
                        <ngx-skeleton-loader [theme]="{ width: '30px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="dividing-line-solid m-0" />

                <!-- Total acumulado -->
                <div class="d-flex justify-content-between align-items-center pl-16 pr-16 footer-table">
                  <div class="font-bold-dali fts-14 d-flex align-items-center color-title-custom">
                    Total acumulado:
                  </div>
                  <div class="font-bold-dali fts-14">
                    <ngx-skeleton-loader [theme]="{ width: '100px', 'border-radius': '5', height: '8px' }"></ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </section>

            <!-- Cards logros -->
           <section>
                <div class="achievement-card-middle">
                  <div class="achievement-content-horizontal">
                    <div class="achievement-left">
                      <div class="achievement-content-left d-flex justify-content-between align-items-center">
                        <div class="achievement-text-content">
                          <h4 class="achievement-title fts-14 font-bold-dali color-neutral-darkest m-0 mb-8">
                            <ngx-skeleton-loader [theme]="{
                          width: '196px',
                          'border-radius': '5',
                          height: '8px',
                          'margin-bottom': '0px',
                          'margin-top': '0px'
                        }"></ngx-skeleton-loader>
                          </h4>
                          <div class="achievement-details d-flex justify-content-between">
                            <div class="achievement-detail-column">
                              <p class="achievement-text fts-14 font-regular color-neutral-dark m-0 mb-4">
                                <ngx-skeleton-loader [theme]="{
                              width: '60px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"></ngx-skeleton-loader>
                              </p>
                              <p class="achievement-value fts-14 font-bold-dali color-neutral-dark m-0">
                                <ngx-skeleton-loader [theme]="{
                              width: '86px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"></ngx-skeleton-loader>
                              </p>
                            </div>
                            <div class="achievement-detail-column">
                              <p class="achievement-text fts-14 font-regular color-neutral-dark m-0 mb-4">
                                <ngx-skeleton-loader [theme]="{
                              width: '46px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"></ngx-skeleton-loader>
                              </p>
                              <p class="achievement-value fts-14 font-bold-dali color-neutral-dark m-0">
                                <ngx-skeleton-loader [theme]="{
                              width: '30px',
                              'border-radius': '5',
                              height: '8px',
                              'margin-bottom': '0px',
                              'margin-top': '0px'
                            }"></ngx-skeleton-loader>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="achievement-medal-right">
                          <ngx-skeleton-loader [theme]="{
                        width: '40px',
                        'border-radius': '5',
                        height: '53px',
                        'margin-bottom': '0px',
                        'margin-top': '0px'
                      }"></ngx-skeleton-loader>
                        </div>
                      </div>
                    </div>
                    <div class="dl-divider mt-16 mb-16"></div>
                    <div class="achievement-right">
                      <div class="achievement-header mb-8">
                        <ngx-skeleton-loader [theme]="{
                      width: '158px',
                      'border-radius': '5',
                      height: '8px',
                      'margin-bottom': '0px',
                      'margin-top': '0px'
                    }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                      width: '30px',
                      'border-radius': '5',
                      height: '8px',
                      'margin-bottom': '0px',
                      'margin-top': '0px'
                    }"></ngx-skeleton-loader>
                      </div>
                      <div class="achievement-details">
                        <p class="achievement-text fts-14 font-regular color-neutral-dark m-0">
                          <ngx-skeleton-loader [theme]="{
                        width: '100px',
                        'border-radius': '5',
                        height: '8px',
                        'margin-bottom': '0px',
                        'margin-top': '0px'
                      }"></ngx-skeleton-loader>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="achievement-card-large mt-16">
                    <div class="achievement-content-large d-flex justify-content-between align-items-center">
                      <div class="achievement-text-content-large">
                        <ngx-skeleton-loader [theme]="{
                    width: '254px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                    width: '254px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                    width: '160px',
                    'border-radius': '5',
                    height: '8px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"></ngx-skeleton-loader>
                      </div>
                      <div class="achievement-focus-right">
                        <ngx-skeleton-loader [theme]="{
                    width: '40px',
                    'border-radius': '5',
                    height: '56px',
                    'margin-bottom': '0px',
                    'margin-top': '0px'
                  }"></ngx-skeleton-loader>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
          </div>
        </div>
      </div>

      <!-- ===== Footer ===== -->
      <div class="progress-footer mt-24">
        <p class="footer-text fts-14 font-regular color-title-custom m-0 ta-s">
          La reevaluación se realizará en enero del {{ currentYear + 1 }}, se tiene en consideración la venta acumulada
          de enero a diciembre de {{ currentYear }}. La venta está calculada con el Importe Real Facturado. Categorías
          no consideradas: panetones, chocolates de taza y socios comerciales.
        </p>
      </div>
    </div>
  </div>
</div>
